import React, { useState, FunctionComponent } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Typography,
  Grid,
  Paper,
  TextField,
  Button,
  CircularProgress,
  Fab,
  Tooltip,
} from "@material-ui/core";
import { Formik, Form } from "formik";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useStore } from "../../../store/index";
import { api } from "../../../api";
import { Select } from "../../Select";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { BarcodeDialog } from "../ItemReturnDialogs/BarcodeDialog";
import { AuthenticationDialog } from "../ItemReturnDialogs/AuthenticationDialog";
import { ItemReturn } from "./ItemReturnPage";
import { SnackBar } from "../../SnackBar";
import RemoveIcon from "@material-ui/icons/DeleteForever";

type formValues = {
  item_number: string;
  quantity: string;
  item_reason: string;
};
// type rowType={
//   Comment: string;
// Status: string;
// check_value: number;
// item_name: string;
// item_type: string;
// plucode: string;
// quantity: number;
// reason_id: number;
// ref_plu: string;
// store_id: number;
// total_amount: number;
// unit_price: number;
// uom_max_loose: string;
// with_bill: boolean;
// }
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    itemDetailsTypography: {
      fontSize: "0.875rem",
      fontWeight: "bold",
      color: "black",
    },
    table: {
      minWidth: 650,
    },
    buttonItemReturnWithoutProgress: {
      color: "#1b5e20",
      position: "absolute",
      left: "55%",
      marginTop: "0.5em",
    },
    buttonItemAddWithoutProgress: {
      color: "#1b5e20",
      position: "absolute",
      left: "81%",
      marginTop: "0.5em",
    },
  })
);
type WithOutBillProps = {
  naviagateToItemReturn: (item: string) => void;
  customer_type: string;
  resetCustomer: () => void;
};
type productObject = {
  quantity: number;
  item_reason: number;
  item_number: string;
  random_id: number;
  unit_price: string;
};
// type KeyboardEvent= {
//   enterKey: boolean;
//   charCode:number;
//   keyCode:number;

// }
export const WithOutBillPage: FunctionComponent<WithOutBillProps> = ({
  naviagateToItemReturn,
  customer_type,
  resetCustomer,
}) => {
  const classes = useStyles();
  const [rows, setRows] = useState<Array<productObject>>([]);
  const [displayTableData, setDisplayTableData] = useState(false);
  const [reasons] = useStore("reasons");
  const [user] = useStore("auth", "user");
  const [barcodeValue, setBarcodeValue] = useState<string>("");
  const [openBarcodeDialog, setOpenBarcodeDialog] = useState(false);
  const [returnOrExchange, setReturnOrexchange] = useState("");
  const [openAuthenticationDialog, setOpenAuthenticationDialog] = useState(
    true
  );
  const [returnTypeError, setReturnTypeError] = useState<boolean>(false);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [itemReturnDays, setItemReturnDays] = useState<string>("");
  const [navigateToWithBillPage, setNavigateToWithBillPage] = useState<boolean>(
    false
  );
  const [validationError, setValidationError] = useState<boolean>(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState<string>(
    ""
  );
  const [returnId, setReturnId] = useState<number>(0);
  const [itemAddingLoading, setItemAddingLoading] = useState<boolean>(false);
  const [itemReturnLoading, setItemReturnLoading] = useState<boolean>(false);
  const [color, setColor] = useState<string>("#d50000");
  const [
    barcodeCancelConfirmationDialog,
    setBarcodeCancelConfirmationDialog,
  ] = useState<boolean>(false);
  const reasonOptions =
    reasons &&
    reasons.map((reason: { [key: string]: any }) => ({
      value: reason.reason_id,
      label: reason.reason_description,
    }));

  const onAuthenticationCheck = async (credentials: any) => {
    try {
      const permissionObject = {
        username: credentials.username,
        password: credentials.password,
        privilege: "item_return",
        action: "edit",
      };
      let credentialResult = await api.post(
        `permissions/verify`,
        {},
        permissionObject
      );
      if (credentialResult === true) {
        // setOpenBarcodeDialog(true);
        // setRePrint(true);
        // console.log("credentialResult", credentialResult);
      } else {
        setOpenBarcodeDialog(false);
      }

      return credentialResult;
    } catch (e) {
      console.log(e);
      throw e;
    }
  };
  // const handleCloseBarcodeDialog = () => {
  //   setOpenBarcodeDialog(false);
  // };
  const handleCloseAuthenticationDialog = () => {
    setOpenAuthenticationDialog(false);
  };
  const onCloseSnackBar = () => {
    setValidationError(false);
  };
  const clearDataAfterPrint = () => {
    setNavigateToWithBillPage(true);
    setOpenBarcodeDialog(false);
    setDisplayTableData(false);
    setOpenAuthenticationDialog(true);
    setRows([]);
    setTotalPrice(0);
    naviagateToItemReturn("true");
  };
  const plucodeValidation = (newItemDetails: any, plucode: string) => {
    // setItemAddingLoading(true);
    const spaceValidation = /\s/;
    const numberValidation = /^[0-9]+$/;
    const isANumber = numberValidation.test(plucode);
    if (plucode !== "") {
      if (spaceValidation.test(plucode)) {
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("White spaces are not allowed");
        setItemAddingLoading(false);
      } else if (!isANumber) {
        setValidationError(true);
        setColor("#d50000");
        setValidationErrorMessage("Only numbers are allowed");
        setItemAddingLoading(false);
      } else {
        setValidationError(false);
        updateData(newItemDetails);
        setItemAddingLoading(true);
      }
    }
  };
  const updateData = async (newItemDetails: any) => {
    setItemAddingLoading(true);
    let store_id = user.store_id;
    const itemValidationObject = {
      store_id: store_id,
      quantity: newItemDetails.quantity, // input value
      plucode: newItemDetails.item_number,
      reason_id: newItemDetails.item_reason.value,
      with_bill: false,
    };
    // console.log("itemValidationObject", itemValidationObject);
    const validationResult = await api.post(
      `item-return-validation`,
      {},
      itemValidationObject
    );
    // console.log("validationResult", validationResult);
    if (validationResult.Status === "True") {
      // if (validationResult.item_type === "STK") {
      // newItemDetails.item_reason = newItemDetails.item_reason.value;
      const totalPriceDetails =
        parseFloat(validationResult.total_amount) + totalPrice;
      setTotalPrice(totalPriceDetails);
      // const duplicateRowDetails = rows && rows.map((row: any) => ({ ...row }));
      // const overlappedRow =
      //   duplicateRowDetails &&
      //   duplicateRowDetails.find(
      //     (row: { [key: string]: any }) =>
      //       row.plucode === validationResult.plucode &&
      //       row.reason_id === validationResult.reason_id
      //   );
      // console.log("duplicateRowDetails",duplicateRowDetails)
      if (rows !== undefined) {
        // if (overlappedRow) {
        //   overlappedRow.quantity =
        //     parseInt(overlappedRow.quantity) +
        //     parseInt(newItemDetails.quantity);
        //     console.log("overlappedRow",overlappedRow)
        //   const nonoverlapedPlucode = rows.filter(
        //     (it: any) => it.plucode !== overlappedRow.plucode
        //   );
        //   const nonOverlappedReason_id=rows.filter(
        //     (it: any) => it.plucode === overlappedRow.plucode&&it.reason_id !== overlappedRow.reason_id
        //   );
        //   const nonoverlaped=nonOverlappedReason_id.concat(nonoverlapedPlucode)
        //   console.log("rows",rows)
        //   console.log("nonoverlapped",nonoverlaped)
        //   const newArray = [overlappedRow, ...nonoverlaped];
        //   console.log("newArray",newArray)
        //   setRows(newArray);
        // } else {
        //       const newArray = [...rows, validationResult];
        //       setRows(newArray);
        //     // }
        //   } else {
        //     console.log("inside validation no row");
        //     console.log(validationResult, "validationReult in else");
        //     setRows([validationResult]);
        //   }
        // } else {
        // newItemDetails.item_reason = newItemDetails.item_reason.value;
        // const totalPriceDetails =
        //   parseFloat(validationResult.total_amount) +
        //   totalPrice;
        // setTotalPrice(totalPriceDetails);
        // const duplicateRowDetails = rows && rows.map((row: any) => ({ ...row }));
        // const overlappedRow =
        //   duplicateRowDetails &&
        //   duplicateRowDetails.find(
        //     (row: { [key: string]: any }) =>
        //       row.plucode === validationResult.plucode &&
        //       row.reason_id === validationResult.reason_id
        //   );
        if (rows !== undefined) {
          // if (overlappedRow) {
          //   overlappedRow.quantity =
          //     parseInt(overlappedRow.quantity) +
          //     parseInt(validationResult.quantity);

          //     const nonoverlapedPlucode = rows.filter(
          //       (it: any) => it.plucode !== overlappedRow.plucode
          //     );
          //     const nonOverlappedReason_id=rows.filter(
          //       (it: any) => it.plucode === overlappedRow.plucode&&it.reason_id !== overlappedRow.reason_id
          //     );
          //     const nonoverlaped=nonOverlappedReason_id.concat(nonoverlapedPlucode)
          //   const newArray = [overlappedRow, ...nonoverlaped];
          //   setRows(newArray);
          // } else {
          // console.log("validationResult", validationResult);
          const newArray = [...rows, validationResult];
          setRows(newArray);
          setItemAddingLoading(false);
          // }
        } else {
          // console.log("validationResult", validationResult);
          // console.log("inside validation no row");
          // console.log(validationResult, "validationReult in else");
          setRows([validationResult]);
          setItemAddingLoading(false);
        }
        //
      }
    }
  };
  const onKeyDown = (keyEvent: any) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };
  const onItemAddingToReturnTable = (values: formValues, resetForm: any) => {
    setItemAddingLoading(true);
    if (!values.quantity.match(/^[0-9]+$/)) {
      setValidationError(true);
      setValidationErrorMessage("Decimal points are not allowed");
      // setItemAddingLoading(false);
    } else if (values.quantity === "0") {
      setValidationError(true);
      setColor("#d50000");
      setValidationErrorMessage("Please give a quantity greater than 0");
      // setItemAddingLoading(false);
    } else if (values.item_reason === "") {
      setValidationError(true);
      setValidationErrorMessage("Please select a reson to return product");
      // setItemAddingLoading(false);
    } else {
      // setItemAddingLoading(true);
      plucodeValidation(values, values.item_number);
      setDisplayTableData(true);
      resetForm();
    }
  };
  const sendItemDetails = async (
    products: Array<productObject>,
    return_type: string
  ) => {
    if (return_type !== "") {
      setBarcodeCancelConfirmationDialog(false);
      setItemReturnLoading(true);
      // const productData = { ...itemDetails[0] }; //Object.assign(productObject, itemDetails);
      const itemDetailsToPass = products.map((product: any) => ({
        bill_id: null,
        terminal_id: null,
        store_id: product.store_id,
        quantity: product.quantity,
        amount: product.unit_price,
        item_ret_type: return_type,
        reason_id: product.reason_id,
        ref_plu: product.ref_plu,
        plu_code: product.plucode,
        uom_max_loose: product.uom_max_loose,
      }));
      const finalObjectToPass = {
        total_amount: totalPrice,
        item_return_details: itemDetailsToPass,
      };
      const createdItemReturn = await api.post(
        `item-return`,
        {},
        finalObjectToPass
      );
      setReturnId(createdItemReturn.item_return_id);
      setBarcodeValue(createdItemReturn.bar_code);
      setItemReturnDays(createdItemReturn.return_days);
      setOpenBarcodeDialog(true);
      setReturnTypeError(false);
      setItemReturnLoading(false);
    } else {
      setReturnTypeError(true);
      setItemReturnLoading(false);
    }
  };
  const handleCloseBarcodeDialogDisAgree = () => {
    setBarcodeCancelConfirmationDialog(false);
  };
  const handleCloseBarcodeDialog = async () => {
    setBarcodeCancelConfirmationDialog(true);
  };
  const handleCloseBarcodeDialogAgree = async () => {
    const itemReturnResult = await api.patch(
      `item-return/cancelItemReturn/${returnId}`,
      {},
      {}
    );
    if (itemReturnResult) {
      setColor("#33691e");
      setValidationError(true);
      setValidationErrorMessage("item return cancelled successfully");
    } else {
      setValidationError(false);
    }
    setOpenBarcodeDialog(false);
  };
  const cancelItemFromReturnTable = (id: number) => {
    const deletedItem = rows && rows.find((row: any) => row.random_id === id);
    // console.log("deletedItem",deletedItem)
    if (deletedItem !== undefined) {
      const reducePriceOfDeletedItem =
        totalPrice - deletedItem.quantity * parseFloat(deletedItem.unit_price);
      // console.log("reducePriceOfDeletedItem",reducePriceOfDeletedItem )
      setTotalPrice(reducePriceOfDeletedItem);
    }
    const deleteAnItem =
      rows && rows.filter((row: productObject) => row.random_id !== id);
    setRows(deleteAnItem);
  };
  return (
    <Grid container spacing={3}>
      {/* {console.log("itemAddingLoading", itemAddingLoading)} */}
      <Grid
        item
        xs={12}
        sm={12}
        // style={{ display: displayItemForm ? "" : "none" }}
      >
        <Paper
          className={classes.paper}
          elevation={4}
          style={{ minHeight: "25em", overflowX: "auto" }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12}>
              <Formik
                enableReinitialize
                initialValues={{
                  item_number: "",
                  item_reason: "",
                  quantity: "",
                }}
                onSubmit={(values, { resetForm }) => {
                  setItemAddingLoading(true);
                  setBarcodeCancelConfirmationDialog(false);
                  onItemAddingToReturnTable(values, resetForm);
                }}
              >
                {({ values, handleChange, setFieldValue, resetForm }) => (
                  <Form>
                    <Grid container spacing={3}>
                      <Grid item xs={6} md={3}>
                        <Grid container direction="column">
                          <Typography style={{ textAlign: "left" }}>
                            Item No.
                          </Typography>
                          <TextField
                            variant="outlined"
                            name="item_number"
                            required
                            onChange={handleChange}
                            value={values.item_number}
                            // onKeyDown={onKeyDown}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Grid container direction="column">
                          <Typography style={{ textAlign: "left" }}>
                            Quantity
                          </Typography>
                          <TextField
                            variant="outlined"
                            name="quantity"
                            required
                            onChange={handleChange}
                            value={values.quantity}
                            onKeyDown={onKeyDown}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Grid container direction="column">
                          <Typography style={{ textAlign: "left" }}>
                            Reason
                          </Typography>
                          <Select
                            options={reasonOptions}
                            style={{ height: "2em" }}
                            value={values.item_reason}
                            required
                            onChange={(value: any) => {
                              setFieldValue("item_reason", value);
                            }}
                          ></Select>
                        </Grid>
                      </Grid>

                      <Grid item xs={6} md={3} style={{ paddingTop: "3em" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          disabled={itemAddingLoading}
                        >
                          submit
                        </Button>
                        {itemAddingLoading && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonItemAddWithoutProgress}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
            <Grid item xs={12} md={12}>
              <Typography
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  color: "#000",
                  textAlign: "right",
                }}
              >
                Total : QR {totalPrice.toFixed(2)}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: displayTableData ? "" : "none" }}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"> Item Name</TableCell>
                    <TableCell align="center"> Item Number</TableCell>
                    <TableCell align="center"> Reason</TableCell>
                    <TableCell align="center"> Quantity</TableCell>
                    <TableCell align="center">Price</TableCell>
                    <TableCell align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows &&
                    rows.map((row: any) => (
                      <TableRow key={row.plucode}>
                        <TableCell align="center">{row.item_name}</TableCell>
                        <TableCell align="center">{row.plucode}</TableCell>
                        <TableCell align="center">
                          {
                            reasonOptions.find(
                              (reason: any) => reason.value === row.reason_id
                            ).label
                          }
                        </TableCell>
                        <TableCell align="center">{row.quantity}</TableCell>
                        <TableCell align="center">{row.unit_price}</TableCell>
                        <TableCell align="center">
                          <Tooltip title="Remove">
                            <Fab
                              color="primary"
                              aria-label="delete"
                              size="small"
                              onClick={() =>
                                cancelItemFromReturnTable(row.random_id)
                              }
                            >
                              <RemoveIcon />
                            </Fab>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <Grid item xs={12}>
                <RadioGroup
                  aria-label="position"
                  row
                  name="item_return"
                  onChange={(event: any) => {
                    setReturnOrexchange(event.target.value);
                  }}
                  value={returnOrExchange}
                >
                  <FormControlLabel
                    value="return"
                    control={<Radio color="primary" />}
                    label="Return"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="exchange"
                    control={<Radio color="primary" />}
                    label="Exchange"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: returnTypeError ? "flex" : "none" }}
              >
                <Typography style={{ color: "red", fontSize: "0.875rem" }}>
                  please select return type...
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => sendItemDetails(rows, returnOrExchange)}
                  disabled={itemReturnLoading}
                >
                  Item Return
                </Button>
                {itemReturnLoading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonItemReturnWithoutProgress}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {openBarcodeDialog ? (
        <BarcodeDialog
          openBarcodeDialog={openBarcodeDialog}
          type={"return"}
          barcodeValue={barcodeValue}
          printDetails={[]}
          rePrint={false}
          handleCloseBarcodeDialog={handleCloseBarcodeDialog}
          totalPrice={parseFloat(totalPrice.toFixed(3))}
          itemReturnDays={itemReturnDays}
          clearDataAfterPrint={clearDataAfterPrint}
          barcodeCancelConfirmationDialog={barcodeCancelConfirmationDialog}
          handleCloseBarcodeDialogAgree={handleCloseBarcodeDialogAgree}
          handleCloseBarcodeDialogDisAgree={handleCloseBarcodeDialogDisAgree}
          isCreditCustomer={customer_type === "R" ? true : false}
          handleClose={clearDataAfterPrint}
        />
      ) : (
        ""
      )}
      {openAuthenticationDialog ? (
        <AuthenticationDialog
          handleCloseAuthenticationDialog={handleCloseAuthenticationDialog}
          openAuthenticationDialog={openAuthenticationDialog}
          onAuthenticationCheck={onAuthenticationCheck}
        />
      ) : (
        ""
      )}
      {validationError ? (
        <SnackBar
          onCloseError={onCloseSnackBar}
          status={validationErrorMessage}
          color={color}
        />
      ) : (
        ""
      )}
      {navigateToWithBillPage ? (
        <ItemReturn
          customer_type={customer_type}
          resetCustomer={resetCustomer}
        />
      ) : (
        ""
      )}
    </Grid>
  );
};
